export enum TestIds {
  QuickSelectionCard = 'QuickSelectionCard',
  CashSelectionSummaryCard = 'CashSelectionSummaryCard',
}
